<template>
  <div
    class="absolute bottom-0 inset-x-0 px-4 pb-6 inset-0 p-0 flex items-center justify-center"
    v-if="isOpen"
  >
    <transition
      enter-active-class="ease-out duration-300"
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="ease-in duration-200"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
      v-if="isOpen"
    >
      <div class="fixed inset-0 transition-opacity" v-on:click="closeModal">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
    </transition>
    <transition
      enter-active-class="ease-out duration-300"
      enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      enter-to-class="opacity-100 translate-y-0 sm:scale-100"
      leave-active-class="ease-in duration-200"
      leave-class="opacity-100 translate-y-0 sm:scale-100"
      leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      v-if="isOpen"
    >
      <div
        class="bg-white top-10 overflow-y-scroll fixed h-99 sm:h-100 mr-4 sm:m-0 rounded-lg shadow-xl transform transition-all max-w-3xl sm:w-full"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <div>
          <!-- <h2
              class="text-center mb-3 text-lg mb-3 leading-6 font-bold text-gray-900"
              id="modal-headline"
            >
              {{ `${job.position} at ${job.companyName}` }}
          </h2>-->
          <div class="bg-white p-6 sm:py-6 sm:px-8 border-b border-gray-200">
            <div class="-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-no-wrap">
              <div class="ml-4 mt-2">
                <h3
                  class="text-lg leading-6 font-medium text-gray-900"
                >{{ `${job.position} at ${job.companyName}` }}</h3>
              </div>
              <div class="hidden sm:block ml-4 mt-2 flex-shrink-0">
                <span class="inline-flex rounded-md shadow-sm">
                  <a v-bind:href="job.url" class="w-full" target="_blank">
                    <button
                      type="button"
                      class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700"
                    >Apply</button>
                  </a>
                </span>
              </div>
            </div>
          </div>
          <div class="px-4 pt-5 pb-4 p-6 sm:p-8">
            <!-- <label class="text-md font-bold">Company</label>
            <p class="mb-2 text-md leading-5 text-gray-600">
              {{ job.companyName }}
            </p>
            <label class="text-md font-bold">Description</label>-->
            <p
              class="text-md leading-5 text-gray-600"
              v-html="marked(job.description)"
              v-if="job.source === 'remoteok.io'"
            ></p>
            <p v-else class="text-md leading-5 text-gray-600" v-html="job.description"></p>
            <label class="text-md font-bold">Source</label>
            <p class="mb-2 text-md leading-5 text-gray-600">{{ job.source }}</p>
            <div class="mt-5 flex flex-wrap">
              <span
                v-for="(tag, i) in job.tags"
                v-bind:key="`${job.company}_${job.position}_${tag}_${i}`"
                class="inline-block mb-1 mr-1 cursor-pointer px-3 py-0.5 rounded-full text-sm font-medium leading-5 bg-indigo-100 text-indigo-800"
                v-on:click="() => addFilterTag(tag)"
              >{{ tag }}</span>
            </div>
            <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
              <span class="flex w-full rounded-md shadow-sm sm:col-start-2">
                <a v-bind:href="job.url" class="w-full" target="_blank">
                  <button
                    type="button"
                    class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-md sm:leading-5"
                  >Apply</button>
                </a>
              </span>
              <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1">
                <button
                  type="button"
                  class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-md sm:leading-5"
                  v-on:click="closeModal"
                >Cancel</button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: Boolean,
    job: Object,
    closeModal: Function
  },
  methods: {
    addFilterTag(tag) {
      this.$root.$emit("emitAddFilterTag", tag);
    }
  }
};
</script>
<style scoped>
.h-100 {
  height: 36rem;
}
.h-99 {
  height: 30rem;
}
</style>
